import { api } from '..'

export const removeTagFromDevice = (deviceId: string) => (tagId: string) =>
  api.delete(`/v1/tags/${tagId}/devices/${deviceId}`)
